import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Heading font styles for sidebar headers
export const gothamFonts = {
  sidebarHeader: {
    fontFamily: "Newsreader, Georgia, serif",
    fontWeight: "600", // semi-bold for main headers
  },
  sidebarSubheader: {
    fontFamily: "Newsreader, Georgia, serif",
    fontWeight: "500", // medium for sub-headers
  },
} as const;
